import { GlobalMessages } from '@shared/localization/messages';

import IconCaretDown from '@/assets/Icons/IconCaretDown.tsx';
import Dropdown from '@/components/atoms/Dropdown.tsx';
import { useMessages } from '@/hooks/messages';

import type { eExportFormat } from '../../model';
import { ExportButton } from '../exportButton';

export interface IExportButtonsSelectorProps {
  exportConfiguration: eExportFormat[];
  onExportButtonClick: (format: eExportFormat) => void;
}

export const ExportButtonsSelector = ({
  exportConfiguration,
  onExportButtonClick,
}: IExportButtonsSelectorProps) => {
  const globalMessages = useMessages(GlobalMessages);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const DropdownComponent = Dropdown as any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ExportButtonComponent = ExportButton as any;

  return (
    <DropdownComponent
      placement='bottom-start'
      btnClassName='!flex h-12 items-center gap-1 rounded-md border bg-white px-4 py-3 text-base dark:text-white hover:border-inherit dark:border-white dark:bg-transparent'
      poperClass='!z-[9999]'
      button={
        <div className='flex gap-1'>
          <span className='ltr:mr-1 rtl:ml-1'>{globalMessages.export()}</span>
          <IconCaretDown className='h-5 w-5' />
        </div>
      }
    >
      <ul className='dark:!bg-c16 !min-w-[140px] rounded'>
        {exportConfiguration?.map((format) => (
          <li key={format} className='dark:hover:bg-c4 px-4 py-2 hover:bg-(--color-light-grey)'>
            <ExportButtonComponent
              format={format}
              onClick={onExportButtonClick}
              key={format}
              inDropdown
            />
          </li>
        ))}
      </ul>
    </DropdownComponent>
  );
};
